module.exports = __webpack_public_path__ + "static/media/circle-check.c3fc6610.png";